import React from 'react';
import {
  Button,
  getClassNameFactory,
  getRehydratableName,
  Heading,
  Sizes,
  Typography,
} from '@dcl/ui';
import { ZoomSplit } from '@dcl/icons/lib/nucleo/large/user-interface';
import { ButtonKind, ButtonColor } from '@dcl/ui/dist/elements/Button';
import { types } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { ISearchHelpTopicsProps } from './types';
import './index.css';

export const SearchHelpTopics: React.FC<ISearchHelpTopicsProps> = (props) => {
  const { title, description, buttonTitle, buttonUrl } = props;
  const getClassName = getClassNameFactory(SearchHelpTopics.displayName);

  return (
    <div
      data-rehydratable={getRehydratableName(SearchHelpTopics.displayName)}
      {...propsToDataAttributes(props)}
    >
      <div
        className={getClassName({ descendantName: 'searchHelpTopicsSection' })}
      >
        <div className={getClassName({ descendantName: 'iconImg' })}>
          <ZoomSplit />
        </div>
        <Heading
          type={types.Large}
          className={getClassName({ descendantName: 'title' })}
        >
          <label htmlFor="browseNewProduct">
            <strong data-testid="shtHeading">{title}</strong>
          </label>
        </Heading>
        <br />
        <Typography
          type={Sizes.XXTRASMALL}
          tag={TypographyTags.P}
          className={getClassName({ descendantName: 'description' })}
          data-testid="shtDescription"
        >
          {description}
        </Typography>
        <br />
        <div className={getClassName({ descendantName: 'signInButton' })}>
          <Button
            kind={ButtonKind.LINK}
            color={ButtonColor.PRIMARY}
            shape="circular"
            href={buttonUrl}
            newWindow={true}
            data-testid="shtBtnTitle"
          >
            {buttonTitle}
          </Button>
        </div>
      </div>
    </div>
  );
};

SearchHelpTopics.displayName = 'SearchHelpTopics';
